import { render, staticRenderFns } from "./a-icon.vue?vue&type=template&id=43998b10&"
import script from "./a-icon.vue?vue&type=script&lang=js&"
export * from "./a-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports